import Table from '@/components/table/components/Table.tsx';
import clientsWithInsuranceApi from '@/features/dashboard/insurances/api/clientsWithInsuranceApi.ts';
import { clientsWithInsuranceApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const ClientsWithInsuranceTable = () => {
  return (
    <Table
      queryKey={clientsWithInsuranceApiQueryKeys.all()}
      fetchData={clientsWithInsuranceApi.getAll}
      fetchTableDef={clientsWithInsuranceApi.getTableDefinition}
      tagTargetType={TaggableType.INSURANCE}
    />
  );
};

export default ClientsWithInsuranceTable;
